import React, { useState, useEffect } from "react";
import "./questionModal.css";

const DetailsModal = ({
  visible,
  onClose,
  onSubmit,
  current_ref = "",
  due_date = "",
  notes = "",
  pay = true,
  termsRequired = false,
}) => {
  const [ref, setRef] = useState(current_ref);
  const [dueDate, setDueDate] = useState(due_date);
  const [noteText, setNoteText] = useState(notes);
  const [terms, setTerms] = useState(false);

  const toInputValue = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const getNextWorkingDay = (baseDate) => {
    const d = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate()
    );
    do {
      d.setDate(d.getDate() + 1);
    } while (d.getDay() === 0 || d.getDay() === 6);
    return d;
  };

  const handleNextWorkingDay = () => {
    const base = new Date();
    const next = getNextWorkingDay(base);
    setDueDate(toInputValue(next));
  };

  useEffect(() => {
    if (visible) {
      setRef(current_ref);
      setDueDate(due_date);
      setNoteText(notes);
      setTerms(false);
    }
  }, [visible, current_ref, due_date, notes]);

  if (!visible) return null;

  const handleSubmit = () => {
    if (termsRequired && !terms) return;

    onSubmit({
      current_ref: ref,
      due_date: dueDate,
      notes: noteText,
      terms: terms,
    });
  };

  const submitDisabled = termsRequired && !terms;

  return (
    <div className="modal_overlay">
      <div className="modal_content">
        <h3>Confirm details:</h3>

        <div className="form_group">
          <label>Reference / PO number:</label>
          <input
            type="text"
            value={ref}
            onChange={(e) => setRef(e.target.value)}
          />
        </div>

        <div className="form_group">
          <label>Required by Date:</label>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />
            <button
              className="nwd button"
              type="button"
              onClick={handleNextWorkingDay}
            >
              Next working day
            </button>
          </div>
        </div>

        <p>
          We will endeavor to achieve your delivery date; a team member will
          provide confirmation.
        </p>

        <div className="form_group">
          <label>Delivery notes:</label>
          <textarea
            rows="3"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
          />
        </div>

        {termsRequired && (
          <div className="form_group">
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={terms}
                onChange={(e) => setTerms(e.target.checked)}
                style={{ marginTop: "3px" }}
              />
              <span>
                I acknowledge that my order has NS lines or modified materials
                as these products are made to order and as such cannot be
                cancelled or returned.
              </span>
            </label>
          </div>
        )}

        <div className="modal_buttons">
          <button
            className="pay_button"
            onClick={handleSubmit}
            disabled={submitDisabled}
          >
            {pay === true ? "Make Payment" : "Accept Quote"}
          </button>
          &nbsp;
          <button className="pay_button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;